import { HiChevronRight } from 'react-icons/hi'
import classNames from 'classnames'

interface NextProps {
    currentPage: number
    pageCount: number
    pagerClass: {
        default: string
        inactive: string
        active: string
        disabled: string
    }
    onNext: () => void
}

const Next = (props: NextProps) => {
    const { currentPage, pageCount, pagerClass, onNext } = props

    const disabled = currentPage >= pageCount

    const onNextClick = () => {
        if (disabled) {
            return
        }
        onNext()
    }

    const pagerNextClass = classNames(
        pagerClass.default,
        disabled && pagerClass.disabled
    )

    return (
        <button className={pagerNextClass} onClick={onNextClick} disabled={disabled}>
            <HiChevronRight />
        </button>
    )
}

export default Next 